import { render, staticRenderFns } from "./taskAdd.vue?vue&type=template&id=168bfac4"
import script from "./taskAdd.vue?vue&type=script&lang=js"
export * from "./taskAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports